export default __webpack_public_path__ + "static/media/Group9211.593f9032.svg";